export default __webpack_public_path__ + "static/media/13-bm.ebe25889.webp";